import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=fd894ef0&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd894ef0')) {
      api.createRecord('fd894ef0', component.options)
    } else {
      api.reload('fd894ef0', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=fd894ef0&", function () {
      api.rerender('fd894ef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-210DrHm22OsEz/JS/comp/childrenage.vue"
export default component.exports